import { Info } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from 'src/components/ui/alert';

const NeedChangesBanner = () => {
  return (
    <Alert className="[&>svg]:size-5 has-[>svg]:grid-cols-[calc(var(--spacing)*5)_1fr] px-6 py-4 bg-accent border-accent-foreground gap-y-1">
      <Info />
      <AlertTitle className="font-bold">Need changes?</AlertTitle>
      <AlertDescription className="text-gray-700/70">
        These are the selections made during the escrow’s setup. To request changes to these selections, complete the
        onboarding, and visit the Settings page.
      </AlertDescription>
    </Alert>
  );
};

export default NeedChangesBanner;
